import React, { useMemo, Fragment, useState, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate, useOutletContext } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import { useGetServiceOfficeListMutation } from "../../../../../reactQueries/commonRQHooks";
import {
  useGetAllRefReqStatusListQuery,
  useUpdateManageRefReqMutation,
  useGetDownloadRefFileQuery,
} from "../../../../../reactQueries/AppApi/rqHooksForReferrals";

import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import { saveAs } from "file-saver";
import { useContext } from "react";
import { Context } from "../../../../../../common/context/Context";
import { manageReferralViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";

const EditManageReferralReq = ({ dataById }) => {
  // const context = useContext(Context);
  // const loggedInUserId = context.userAccountData?.id;

  const { loggedInUser } = useGetLoggedInUserDetails();
  const isFirstLoadRef = React.useRef(true);
  const {
    clientPortalAdminRoleId,
    isEnterpriseAdmin,
    id: userId,
    firstName,
    lastName,
  } = loggedInUser;

  const userName = `${firstName} ${lastName}`;

  // console.log("userName", userName)

  let navigate = useNavigate();
  const [id, setId] = useState("");
  const [brandId, setBrandId] = useState("");

  const downloadFile = () => {
    setId(dataById?.Id);
    setBrandId(dataById.BrandId);
  };
  const docStatus = dataById.DocumentStatus?.toLowerCase();
  const isDeletedStatus =
    docStatus === "incomplete-deleted".toLowerCase() ||
    docStatus === "completed-deleted".toLowerCase();
  //
  const {
    isSuccess: isSuccessOnDownloadFile,
    isFetching: isFetchingOnDownloadFile,
    isLoading: isLoadingOnDownloadFile,
    error: errorOnDownloadFile,
    data: downloadFileData,
    isError: isErrorOnDownloadFile,
    isFetched: isFetchedOnDownloadFile,
  } = useGetDownloadRefFileQuery({
    Id: id,
    BrandId: brandId,
  });
  // api - update manage ref req mutation
  const {
    mutate: updateManageRefReq,
    isError: isErrorOnUpdate,
    isLoading: isLoadingOnUpdate,
    isSuccess: isSuccessOnUpdate,
    data: dataOnUpdate,
    error: errorOnUpdate,
  } = useUpdateManageRefReqMutation();

  const schema = yup.object().shape({
    status: yup
      .object()
      .label("This field")
      .required()
      .typeError("This field is a required"),
    reason_rejection: yup
      .string()
      .label("This field")
      .max(2000)
      .when("status", (status, schema) => {
        if (status?.selectOptionLabel === "Rejected") {
          return schema.required();
        } else {
          return schema.notRequired();
        }
      }),
  });

  const defaultValues = {
    ref_docname: dataById?.DocumentName,
    submitted_by: `${dataById?.CreatedBy}, ${dataById.EmailAddress}`,
    submitted_on: dataById?.SubmittedOn,
    client_account: dataById?.ClientAccountName,
    client_sub_account: dataById?.ClientSubAccountName,
    reason_rejection: "",
  };
  const rhfFormInstance = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { setValue, getValues, watch } = rhfFormInstance;

  const status = watch("status");

  // console.log("status:", status)

  // api - get service office list data
  const {
    mutate: getServiceOfficeList,
    isError: isErrorOnServiceOfficeList,
    isFetching: isFetchingOnServiceOfficeList,
    isSuccess: isSuccessOnServiceOfficeList,
    data: serviceOfficeListData,
    error: errorOnServiceOfficeList,
  } = useGetServiceOfficeListMutation();

  useEffect(() => {
    getServiceOfficeList();
  }, []);

  // api - get status dropdown list
  const {
    data: reqStatusListData,
    isError: isErrorOnReqStatusList,
    isFetching: isLoadingOnReqStatusList,
    isSuccess: isSuccessOnReqStatusList,
    error: errorOnReqStatusList,
  } = useGetAllRefReqStatusListQuery();

  // setting existing service office values
  useEffect(() => {
    if (
      !!serviceOfficeListData?.data &&
      !!serviceOfficeListData?.data?.length
    ) {
      let serviceOfficeList = [];
      dataById.rightOfficeKey.forEach((eachServiceOffice) => {
        const foundItem = serviceOfficeListData?.data.find((item) => {
          return item.rightOfficeKey === eachServiceOffice;
        });

        if (!!foundItem) {
          serviceOfficeList.push(foundItem.masterRightOfficeName);
        }
      });

      setValue("service_office", serviceOfficeList.toString() || "", {
        shouldValidate: true,
      });
    }
  }, [serviceOfficeListData?.data, dataById]);

  const reqStatusAutocompleteList =
    !!reqStatusListData &&
    (() => {
      if (dataById?.DocumentStatus === "OnHold") {
        return reqStatusListData
          .filter(
            (item) =>
              item.DocumentStatus === "In progress" ||
              item.DocumentStatus === "Rejected"
          )
          .map((item) => ({
            id: item.StatusId,
            selectOptionLabel: item.DocumentStatus,
            selectOptionValue: item.StatusId,
            extraData: item,
          }));
      }
      return reqStatusListData
        .filter(
          (item) =>
            item.DocumentStatus === "Approved/Completed" ||
            item.DocumentStatus === "In progress" ||
            item.DocumentStatus === "Rejected"
        )
        .map((item) => ({
          id: item.StatusId,
          selectOptionLabel: item.DocumentStatus,
          selectOptionValue: item.StatusId,
          extraData: item,
        }));
    })();

  useEffect(() => {
    const isRejected = dataById?.DocumentStatus === "Rejected";

    if (isFirstLoadRef.current) {
      if (dataById?.DocumentStatus === "Rejected" && isRejected) {
        setValue("reason_rejection", dataById?.DocumentRejectionReason || "", {
          shouldValidate: true,
        });
      } else {
        setValue("reason_rejection", "", { shouldValidate: true });
      }
      isFirstLoadRef.current = false;
      return;
    }
    if (!isRejected) {
      setValue("reason_rejection", "", { shouldValidate: true });
    }
  }, [status, dataById, setValue]);

  useEffect(() => {
    if (!!reqStatusListData && !!reqStatusListData?.length) {
      let selectedValue = {};
      if (isDeletedStatus) {
        const foundItem = reqStatusListData.find(
          (item) => item.DocumentStatus === dataById?.DocumentStatus
        );
        if (foundItem) {
          selectedValue = {
            id: foundItem.StatusId,
            selectOptionLabel: foundItem.DocumentStatus,
            selectOptionValue: foundItem.StatusId,
            extraData: foundItem,
          };
          setValue("status", selectedValue, { shouldValidate: true });
          return;
        }
      }

      if (dataById?.DocumentStatus === "OnHold") {
        const foundItem = reqStatusListData.find(
          (item) => item.DocumentStatus === "OnHold"
        );
        if (foundItem) {
          selectedValue = {
            id: foundItem.StatusId,
            selectOptionLabel: `${foundItem.DocumentStatus}`,
            selectOptionValue: foundItem.StatusId,
            extraData: foundItem,
          };
          setValue("status", selectedValue, { shouldValidate: true });
          return;
        }
      }

      const foundItem = reqStatusListData.find(
        (item) => item.StatusId === dataById.StatusId
      );
      if (foundItem) {
        selectedValue = {
          id: foundItem.StatusId,
          selectOptionLabel: `${foundItem.DocumentStatus}`,
          selectOptionValue: foundItem.StatusId,
          extraData: foundItem,
        };
      }
      setValue("status", selectedValue || "", {
        shouldValidate: true,
      });
    }
  }, [reqStatusListData, dataById, isDeletedStatus, setValue]);

  useEffect(() => {
    if (!!isSuccessOnDownloadFile) {
      saveAs(downloadFileData, `${dataById?.DocumentName}`);
      setId("");
      setBrandId("");
    }
    if (!!isErrorOnDownloadFile) {
      // console.log("isErrorOnDownloadFile called");
      setId("");
      setBrandId("");
    }
  }, [isSuccessOnDownloadFile, isErrorOnDownloadFile]);

  const onSubmit = (data) => {
    // console.log("form data", data);
    const body = {
      Id: dataById?.Id,
      StatusId: data?.status?.id,
      DocumentRejectionReason: data?.reason_rejection || "",
      UpdatedFrom: userId,
      UpdatedBy: userName,
    };
    updateManageRefReq({ body });
  };

  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      navigate(manageReferralViewPath);
    }
  }, [isSuccessOnUpdate]);

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity();
  useEffect(() => {
    if (
      !!isSuccessOnUpdate &&
      (status.selectOptionValue === 2 || status.selectOptionValue === 3)
    ) {
      trackActivity({
        activitySuccess: !!isSuccessOnUpdate,
        actionType:
          status.selectOptionValue === 2
            ? "ReferralAccepted"
            : "ReferralRejected",
        itemId: dataById.Id,
      });
    }
  });

  const referralsCMSData = useOutletContext();

  // const fetchManageRefReqListLabel = (key) => {
  //   if (referralsCMSData && referralsCMSData?.pageContent["ManageReferralRequestList"]) {
  //       const referralsCMSDataLabel = referralsCMSData.pageContent["ManageReferralRequestList"];
  //       return returnLabel(referralsCMSDataLabel?.Labels, key)
  //   }
  //   return '';
  // }

  const fetchAssignRefReqLabel = (key) => {
    if (
      referralsCMSData &&
      referralsCMSData?.pageContent["AssignReferralRequest"]
    ) {
      const referralsCMSDataLabel =
        referralsCMSData.pageContent["AssignReferralRequest"];
      return returnLabel(referralsCMSDataLabel?.Labels, key);
    }
  };

  const fetchManageRefReqLabel = (key) => {
    if (
      referralsCMSData &&
      referralsCMSData?.pageContent["ManageReferralRequest"]
    ) {
      const referralsCMSDataLabel =
        referralsCMSData.pageContent["ManageReferralRequest"];
      return returnLabel(referralsCMSDataLabel?.Labels, key);
    }
  };

  const fetchCommonCMSLabel = (key) => {
    if (referralsCMSData && referralsCMSData?.pageContent["CommonComponent"]) {
      const commonCMSDataLabel =
        referralsCMSData.pageContent["CommonComponent"];
      return returnLabel(commonCMSDataLabel?.Labels, key);
    }
    return "";
  };

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
      return labelArray.find((x) => x.Key === key)?.Phrase || "";
    }
    return "";
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Manage Referral Request */}
        {fetchManageRefReqLabel("ManageReferralRequest.ManageReferralRequest")}
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={manageReferralViewPath}
        >
          {/* Manage Referral Requests */}
          {referralsCMSData?.pageContent["ManageReferralRequestList"]?.Title}
        </Button>
      </Stack>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <MpgItem sx={{ padding: { xs: "20px" } }}>
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {/* Referral Details */}
                {fetchManageRefReqLabel(
                  "ManageReferralRequest.ReferralDetails"
                )}
              </Typography>

              <div>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"ref_docname"}
                  label={fetchManageRefReqLabel(
                    "ManageReferralRequest.ReferralFileName"
                  )} //{"Referral file name"}
                  multiline
                  rows={2}
                  fullWidth
                  disabled
                />

                <span
                  onClick={isDeletedStatus ? undefined : () => downloadFile()}
                  style={{
                    color: isDeletedStatus ? "#9e9e9e" : "#0F3E8A", // grey when disabled
                    textDecoration: "none",
                    cursor: isDeletedStatus ? "default" : "pointer",
                    pointerEvents: isDeletedStatus ? "none" : "auto",
                  }}
                >
                  {dataById?.DocumentName}
                </span>
              </div>

              <MpgAutocompleteSingle
                rhfFormInstance={rhfFormInstance}
                name={"status"}
                label={fetchManageRefReqLabel("ManageReferralRequest.Status")}
                fullWidth
                optionList={reqStatusAutocompleteList || []}
                disabled={
                  isDeletedStatus ||
                  (reqStatusAutocompleteList?.length === 1 &&
                    reqStatusAutocompleteList[0]?.disabled)
                }
              />

              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"reason_rejection"}
                label={fetchManageRefReqLabel(
                  "ManageReferralRequest.RejectionReason"
                )} //{"Rejection Reason"}
                placeholder={
                  fetchManageRefReqLabel(
                    "ManageReferralRequest.PlaceholderRejectionReasonOtherText"
                  ) + "..."
                } //{"Rejection reason..."}
                multiline
                rows={6}
                fullWidth
                disabled={
                  status?.selectOptionLabel === "Rejected" ? false : true
                }
              />
            </MpgItem>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MpgItem>
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                Client User Information
              </Typography>
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"submitted_by"}
                label={fetchAssignRefReqLabel(
                  "AssignReferralRequest.SubmittedByClientUser"
                )} //{"Submitted By Client User"}
                fullWidth
                disabled={true}
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"submitted_on"}
                label={fetchManageRefReqLabel(
                  "ManageReferralRequest.SubmittedOn"
                )} //{"Submitted On"}
                fullWidth
                disabled={true}
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"client_account"}
                label={fetchManageRefReqLabel(
                  "ManageReferralRequest.UserBelongsToClientAccount"
                )} //{"User belongs to Client Account"}
                fullWidth
                disabled={true}
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"client_sub_account"}
                label={fetchManageRefReqLabel(
                  "ManageReferralRequest.UserBelongsToClientSubAccount Group"
                )} //{"User belongs to Client Sub-Account Group"}
                fullWidth
                disabled={true}
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                label={fetchManageRefReqLabel(
                  "ManageReferralRequest.UserBelongsToServiceOffice"
                )} //{"User belongs to Service Office"}
                name={"service_office"}
                multiline
                rows={4}
                fullWidth
                disabled
              />
            </MpgItem>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            variant="outlined"
            size="small"
            type="submit"
            sx={{ marginTop: "15px" }}
            disabled={isDeletedStatus}
          >
            {fetchCommonCMSLabel("Common.Save") /* Save */}
          </Button>
        </Grid>
      </Box>

      {/** error dialog on update action */}
      <MpgErrorDialog open={!!isErrorOnUpdate} />
      <MpgLoadingDialog open={!!isLoadingOnUpdate} />
    </Box>
  );
};

export default EditManageReferralReq;
